import { tViews } from "../../../../../utils/table";

export default {
  get title() { return tViews('dashletSiteViewSites'); },
  theme: "quality",
  text: {
    good: {
      get title() { return tViews('applicationDonutLabelGoodAvailable'); },
      get tooltip() { return tViews('applicationOverviewLabelGood'); }
    },
    fair: {
      get title() { return tViews('applicationDonutLabelFairAvailable'); },
      get tooltip() { return tViews('applicationOverviewLabelFair'); }
    },
    bad: {
      get title() { return tViews('applicationDonutLabelPoorAvailable'); },
      get tooltip() { return tViews('applicationOverviewLabelPoor'); }
    },
    notAvailable: {
      get title() { return tViews('applicationDonutLabelNAAvailable'); },
      get tooltip() { return tViews('applicationOverviewLabelNotAvailable'); }
    }
  }
};
